export enum RouteKeys {
  List = '/subcategory',
  New = '/subcategory/new',
  Edit = '/subcategory/:id',
}
